(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_2fbaca8"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__podFolgeBereit) return;
    window.__podFolgeBereit = true;

    var aktiv = null;        // { folge, controller }
    var offenesMenu = null;  // { menu, knopf }
    var api = null;
    var apiStatus = 'neu';   // neu | laedt | bereit | fehler
    var apiWarteschlange = [];

    /* ---------- Spotify iFrame API (für direktes Abspielen) ---------- */
    function apiLaden(cb) {
      if (apiStatus === 'bereit') { cb(api); return; }
      if (apiStatus === 'fehler') { cb(null); return; }
      apiWarteschlange.push(cb);
      if (apiStatus === 'laedt') return;
      apiStatus = 'laedt';

      var fertig = function (a) {
        if (apiStatus !== 'laedt') return;
        api = a || null;
        apiStatus = a ? 'bereit' : 'fehler';
        var q = apiWarteschlange;
        apiWarteschlange = [];
        q.forEach(function (f) { f(api); });
      };

      var vorher = window.onSpotifyIframeApiReady;
      window.onSpotifyIframeApiReady = function (a) {
        if (typeof vorher === 'function') { try { vorher(a); } catch (e) {} }
        fertig(a);
      };

      var s = document.createElement('script');
      s.src = 'https://open.spotify.com/embed/iframe-api/v1';
      s.async = true;
      s.onerror = function () { fertig(null); };
      document.head.appendChild(s);
      setTimeout(function () { fertig(null); }, 4000);
    }

    /* ---------- Einstellungen aus dem Kopf-Block (falls vorhanden) ---------- */
    function einstellungen(folge) {
      var bereich = folge.closest('.shopify-section') || document;
      var el = bereich.querySelector('[data-pod-einstellungen]') || document.querySelector('[data-pod-einstellungen]');
      var d = el ? el.dataset : {};

      var kanaele = [];
      String(d.podKanaele || 'link,whatsapp,email,linkedin,facebook,bluesky')
        .toLowerCase()
        .split(',')
        .forEach(function (k) {
          k = k.trim();
          if (!k) return;
          if (k === 'linkedin') kanaele.push('linkedin');
          else if (k.indexOf('link') === 0 || k.indexOf('kopier') > -1 || k === 'copy') kanaele.push('link');
          else if (k.indexOf('whatsapp') > -1) kanaele.push('whatsapp');
          else if (k.indexOf('mail') > -1) kanaele.push('email');
          else if (k.indexOf('facebook') > -1) kanaele.push('facebook');
          else if (k.indexOf('bluesky') > -1) kanaele.push('bluesky');
          else if (k === 'x' || k.indexOf('twitter') > -1) kanaele.push('x');
        });
      if (!kanaele.length) kanaele = ['link', 'whatsapp', 'email', 'linkedin', 'facebook', 'bluesky'];

      var theme = String(d.podPlayerTheme || '');
      return {
        hoehe: /352|gross/i.test(d.podPlayerHoehe || '') ? 352 : 152,
        dunkel: /dunkel|dark/i.test(theme) || theme === '0',
        teilenSpotify: /spotify/i.test(d.podTeilenLink || ''),
        kanaele: kanaele
      };
    }

    /* ---------- Player ---------- */
    function status(folge, offen) {
      folge.classList.toggle('is-offen', offen);
      var titel = folge.getAttribute('data-pod-titel') || '';
      folge.querySelectorAll('[data-pod-play]').forEach(function (b) {
        b.setAttribute('aria-expanded', offen ? 'true' : 'false');
        b.setAttribute('aria-label', (offen ? 'Player schliessen: ' : 'Folge abspielen: ') + titel);
      });
      var label = folge.querySelector('[data-pod-play-label]');
      if (label) label.textContent = offen ? 'Schliessen' : 'Anhören';
    }

    function schliessen() {
      if (!aktiv) return;
      var f = aktiv.folge;
      if (aktiv.controller) { try { aktiv.controller.destroy(); } catch (e) {} }
      var box = f.querySelector('[data-pod-player]');
      if (box) {
        box.innerHTML = '';
        box.style.minHeight = '';
        box.hidden = true;
      }
      status(f, false);
      aktiv = null;
    }

    function iframeEinsetzen(box, id, cfg) {
      var src = 'https://open.spotify.com/embed/episode/' + encodeURIComponent(id) +
        '?utm_source=generator' + (cfg.dunkel ? '&theme=0' : '');
      box.innerHTML = '<iframe src="' + src + '" height="' + cfg.hoehe +
        '" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" title="Spotify-Player"></iframe>';
    }

    function oeffnen(folge) {
      var id = folge.getAttribute('data-pod-episode');
      if (!id) return;
      if (aktiv && aktiv.folge === folge) { schliessen(); return; }
      schliessen();
      menuZu();

      var box = folge.querySelector('[data-pod-player]');
      if (!box) return;
      var cfg = einstellungen(folge);
      var eintrag = { folge: folge, controller: null };
      aktiv = eintrag;
      status(folge, true);
      box.hidden = false;
      box.style.minHeight = cfg.hoehe + 'px';
      box.innerHTML = '<div></div>';

      if (cfg.dunkel) { iframeEinsetzen(box, id, cfg); return; }

      apiLaden(function (a) {
        if (aktiv !== eintrag) return;
        if (!a) { iframeEinsetzen(box, id, cfg); return; }
        try {
          a.createController(box.firstElementChild, { uri: 'spotify:episode:' + id, width: '100%', height: cfg.hoehe }, function (ctrl) {
            if (aktiv !== eintrag) { try { ctrl.destroy(); } catch (e) {} return; }
            eintrag.controller = ctrl;
            ctrl.addListener('ready', function () { try { ctrl.play(); } catch (e) {} });
          });
        } catch (e) {
          iframeEinsetzen(box, id, cfg);
        }
      });
    }

    /* ---------- Teilen ---------- */
    function esc(t) {
      return String(t).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    function menuZu() {
      if (!offenesMenu) return;
      offenesMenu.menu.hidden = true;
      offenesMenu.menu.innerHTML = '';
      offenesMenu.knopf.setAttribute('aria-expanded', 'false');
      offenesMenu = null;
    }

    function teilenLink(folge, cfg) {
      var sp = folge.getAttribute('data-pod-spotify');
      if (cfg.teilenSpotify && sp) return sp;
      return location.origin + location.pathname + '#' + folge.id;
    }

    var KANAL = {
      whatsapp: ['WhatsApp', function (u, t) { return 'https://wa.me/?text=' + encodeURIComponent(t + ' ' + u); }],
      email: ['E-Mail', function (u, t) { return 'mailto:?subject=' + encodeURIComponent(t) + '&body=' + encodeURIComponent(u); }],
      linkedin: ['LinkedIn', function (u) { return 'https://www.linkedin.com/sharing/share-offsite/?url=' + encodeURIComponent(u); }],
      facebook: ['Facebook', function (u) { return 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(u); }],
      bluesky: ['Bluesky', function (u, t) { return 'https://bsky.app/intent/compose?text=' + encodeURIComponent(t + ' ' + u); }],
      x: ['X', function (u, t) { return 'https://x.com/intent/tweet?text=' + encodeURIComponent(t) + '&url=' + encodeURIComponent(u); }]
    };

    function teilen(folge, knopf) {
      var cfg = einstellungen(folge);
      var url = teilenLink(folge, cfg);
      var titel = folge.getAttribute('data-pod-titel') || document.title;
      var touch = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;

      if (navigator.share && touch) {
        navigator.share({ title: titel, url: url }).catch(function () {});
        return;
      }

      var menu = folge.querySelector('[data-pod-share-menu]');
      if (!menu) return;
      if (offenesMenu && offenesMenu.menu === menu) { menuZu(); return; }
      menuZu();

      var html = '';
      cfg.kanaele.forEach(function (k) {
        if (k === 'link') {
          html += '<li><button type="button" data-pod-copy data-url="' + esc(url) + '">Link kopieren</button></li>';
        } else if (KANAL[k]) {
          var ziel = KANAL[k][1](url, titel);
          html += '<li><a href="' + esc(ziel) + '"' + (k === 'email' ? '' : ' target="_blank" rel="noopener"') + '>' + KANAL[k][0] + '</a></li>';
        }
      });
      menu.innerHTML = html;
      menu.hidden = false;
      knopf.setAttribute('aria-expanded', 'true');
      offenesMenu = { menu: menu, knopf: knopf };
      var erstes = menu.querySelector('a, button');
      if (erstes) erstes.focus();
    }

    function altKopieren(text) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta);
    }

    function kopieren(knopf) {
      var url = knopf.getAttribute('data-url');
      var ok = function () {
        knopf.textContent = 'Link kopiert';
        setTimeout(menuZu, 1200);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(ok, function () { altKopieren(url); ok(); });
      } else {
        altKopieren(url);
        ok();
      }
    }

    /* ---------- Mehr anzeigen ---------- */
    function pruefeMehr() {
      document.querySelectorAll('.pod-folge').forEach(function (f) {
        var text = f.querySelector('[data-pod-text]');
        var knopf = f.querySelector('[data-pod-mehr]');
        if (!text || !knopf) return;
        if (text.classList.contains('is-offen')) { knopf.hidden = false; return; }
        knopf.hidden = !(text.scrollHeight > text.clientHeight + 2);
      });
    }

    function mehr(knopf) {
      var f = knopf.closest('.pod-folge');
      var text = f && f.querySelector('[data-pod-text]');
      if (!text) return;
      var offen = text.classList.toggle('is-offen');
      knopf.textContent = offen ? 'Weniger anzeigen' : 'Mehr anzeigen';
      knopf.setAttribute('aria-expanded', offen ? 'true' : 'false');
    }

    /* ---------- Sprunglink #folge-… ---------- */
    function zeigeAnker() {
      var h = '';
      try { h = decodeURIComponent(location.hash.slice(1)); } catch (e) { return; }
      if (h.indexOf('folge-') !== 0) return;
      var f = document.getElementById(h);
      if (!f || !f.classList.contains('pod-folge')) return;
      f.classList.remove('pod-versteckt');
      if (f.style.display === 'none') f.style.display = '';
      f.hidden = false;
      pruefeMehr();
      f.scrollIntoView({ behavior: 'smooth', block: 'center' });
      f.classList.add('is-hervorgehoben');
      setTimeout(function () { f.classList.remove('is-hervorgehoben'); }, 2000);
    }

    /* ---------- Hinweis bei doppelten Folgennummern (nur Editor) ---------- */
    function pruefeDoppelt() {
      if (!(window.Shopify && window.Shopify.designMode)) return;
      var gesehen = {};
      document.querySelectorAll('.pod-folge').forEach(function (f) {
        var alt = f.querySelector('.pod-hinweis--doppelt');
        if (alt) alt.parentNode.removeChild(alt);
        if (gesehen[f.id]) {
          var p = document.createElement('p');
          p.className = 'pod-hinweis pod-hinweis--doppelt';
          p.textContent = 'Nur im Editor sichtbar: Diese Folgennummer kommt mehrmals vor. Bitte jeder Folge eine eigene Nummer geben.';
          (f.querySelector('.pod-folge__text') || f).appendChild(p);
        }
        gesehen[f.id] = true;
      });
    }

    /* ---------- Ein einziger Listener für alle Folgen ---------- */
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var el;

      if ((el = t.closest('[data-pod-play]'))) {
        var f1 = el.closest('.pod-folge');
        if (f1) { e.preventDefault(); oeffnen(f1); }
      } else if ((el = t.closest('[data-pod-share]'))) {
        var f2 = el.closest('.pod-folge');
        if (f2) { e.preventDefault(); teilen(f2, el); }
      } else if ((el = t.closest('[data-pod-copy]'))) {
        e.preventDefault();
        kopieren(el);
      } else if ((el = t.closest('[data-pod-mehr]'))) {
        e.preventDefault();
        mehr(el);
      } else if (offenesMenu) {
        if (t.closest('[data-pod-share-menu]')) setTimeout(menuZu, 100);
        else menuZu();
      }

      setTimeout(pruefeMehr, 60);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && offenesMenu) {
        var k = offenesMenu.knopf;
        menuZu();
        k.focus();
      }
    });

    function aufraeumen() {
      if (aktiv && !document.body.contains(aktiv.folge)) {
        if (aktiv.controller) { try { aktiv.controller.destroy(); } catch (e) {} }
        aktiv = null;
      }
      if (offenesMenu && !document.body.contains(offenesMenu.menu)) offenesMenu = null;
    }

    function start() {
      aufraeumen();
      pruefeMehr();
      pruefeDoppelt();
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();

    function ankerStart() { setTimeout(zeigeAnker, 400); }
    if (document.readyState === 'complete') ankerStart();
    else window.addEventListener('load', ankerStart);
    window.addEventListener('hashchange', zeigeAnker);

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(pruefeMehr, 150);
    });

    ['shopify:section:load', 'shopify:block:select', 'shopify:block:deselect'].forEach(function (ev) {
      document.addEventListener(ev, function () { setTimeout(start, 50); });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ai_gen_block_52a46d3"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__podFolgeBereit) return;
    window.__podFolgeBereit = true;

    var aktiv = null;        // { folge, controller }
    var offenesMenu = null;  // { menu, knopf }
    var api = null;
    var apiStatus = 'neu';   // neu | laedt | bereit | fehler
    var apiWarteschlange = [];

    /* ---------- Spotify iFrame API (für direktes Abspielen) ---------- */
    function apiLaden(cb) {
      if (apiStatus === 'bereit') { cb(api); return; }
      if (apiStatus === 'fehler') { cb(null); return; }
      apiWarteschlange.push(cb);
      if (apiStatus === 'laedt') return;
      apiStatus = 'laedt';

      var fertig = function (a) {
        if (apiStatus !== 'laedt') return;
        api = a || null;
        apiStatus = a ? 'bereit' : 'fehler';
        var q = apiWarteschlange;
        apiWarteschlange = [];
        q.forEach(function (f) { f(api); });
      };

      var vorher = window.onSpotifyIframeApiReady;
      window.onSpotifyIframeApiReady = function (a) {
        if (typeof vorher === 'function') { try { vorher(a); } catch (e) {} }
        fertig(a);
      };

      var s = document.createElement('script');
      s.src = 'https://open.spotify.com/embed/iframe-api/v1';
      s.async = true;
      s.onerror = function () { fertig(null); };
      document.head.appendChild(s);
      setTimeout(function () { fertig(null); }, 4000);
    }

    /* ---------- Einstellungen aus dem Kopf-Block (falls vorhanden) ---------- */
    function einstellungen(folge) {
      var bereich = folge.closest('.shopify-section') || document;
      var el = bereich.querySelector('[data-pod-einstellungen]') || document.querySelector('[data-pod-einstellungen]');
      var d = el ? el.dataset : {};

      var kanaele = [];
      String(d.podKanaele || 'link,whatsapp,email,linkedin,facebook,bluesky')
        .toLowerCase()
        .split(',')
        .forEach(function (k) {
          k = k.trim();
          if (!k) return;
          if (k === 'linkedin') kanaele.push('linkedin');
          else if (k.indexOf('link') === 0 || k.indexOf('kopier') > -1 || k === 'copy') kanaele.push('link');
          else if (k.indexOf('whatsapp') > -1) kanaele.push('whatsapp');
          else if (k.indexOf('mail') > -1) kanaele.push('email');
          else if (k.indexOf('facebook') > -1) kanaele.push('facebook');
          else if (k.indexOf('bluesky') > -1) kanaele.push('bluesky');
          else if (k === 'x' || k.indexOf('twitter') > -1) kanaele.push('x');
        });
      if (!kanaele.length) kanaele = ['link', 'whatsapp', 'email', 'linkedin', 'facebook', 'bluesky'];

      var theme = String(d.podPlayerTheme || '');
      return {
        hoehe: /352|gross/i.test(d.podPlayerHoehe || '') ? 352 : 152,
        dunkel: /dunkel|dark/i.test(theme) || theme === '0',
        teilenSpotify: /spotify/i.test(d.podTeilenLink || ''),
        kanaele: kanaele
      };
    }

    /* ---------- Player ---------- */
    function status(folge, offen) {
      folge.classList.toggle('is-offen', offen);
      var titel = folge.getAttribute('data-pod-titel') || '';
      folge.querySelectorAll('[data-pod-play]').forEach(function (b) {
        b.setAttribute('aria-expanded', offen ? 'true' : 'false');
        b.setAttribute('aria-label', (offen ? 'Player schliessen: ' : 'Folge abspielen: ') + titel);
      });
      var label = folge.querySelector('[data-pod-play-label]');
      if (label) label.textContent = offen ? 'Schliessen' : 'Anhören';
    }

    function schliessen() {
      if (!aktiv) return;
      var f = aktiv.folge;
      if (aktiv.controller) { try { aktiv.controller.destroy(); } catch (e) {} }
      var box = f.querySelector('[data-pod-player]');
      if (box) {
        box.innerHTML = '';
        box.style.minHeight = '';
        box.hidden = true;
      }
      status(f, false);
      aktiv = null;
    }

    function iframeEinsetzen(box, id, cfg) {
      var src = 'https://open.spotify.com/embed/episode/' + encodeURIComponent(id) +
        '?utm_source=generator' + (cfg.dunkel ? '&theme=0' : '');
      box.innerHTML = '<iframe src="' + src + '" height="' + cfg.hoehe +
        '" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" title="Spotify-Player"></iframe>';
    }

    function oeffnen(folge) {
      var id = folge.getAttribute('data-pod-episode');
      if (!id) return;
      if (aktiv && aktiv.folge === folge) { schliessen(); return; }
      schliessen();
      menuZu();

      var box = folge.querySelector('[data-pod-player]');
      if (!box) return;
      var cfg = einstellungen(folge);
      var eintrag = { folge: folge, controller: null };
      aktiv = eintrag;
      status(folge, true);
      box.hidden = false;
      box.style.minHeight = cfg.hoehe + 'px';
      box.innerHTML = '<div></div>';

      if (cfg.dunkel) { iframeEinsetzen(box, id, cfg); return; }

      apiLaden(function (a) {
        if (aktiv !== eintrag) return;
        if (!a) { iframeEinsetzen(box, id, cfg); return; }
        try {
          a.createController(box.firstElementChild, { uri: 'spotify:episode:' + id, width: '100%', height: cfg.hoehe }, function (ctrl) {
            if (aktiv !== eintrag) { try { ctrl.destroy(); } catch (e) {} return; }
            eintrag.controller = ctrl;
            ctrl.addListener('ready', function () { try { ctrl.play(); } catch (e) {} });
          });
        } catch (e) {
          iframeEinsetzen(box, id, cfg);
        }
      });
    }

    /* ---------- Teilen ---------- */
    function esc(t) {
      return String(t).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    function menuZu() {
      if (!offenesMenu) return;
      offenesMenu.menu.hidden = true;
      offenesMenu.menu.innerHTML = '';
      offenesMenu.knopf.setAttribute('aria-expanded', 'false');
      offenesMenu = null;
    }

    function teilenLink(folge, cfg) {
      var sp = folge.getAttribute('data-pod-spotify');
      if (cfg.teilenSpotify && sp) return sp;
      return location.origin + location.pathname + '#' + folge.id;
    }

    var KANAL = {
      whatsapp: ['WhatsApp', function (u, t) { return 'https://wa.me/?text=' + encodeURIComponent(t + ' ' + u); }],
      email: ['E-Mail', function (u, t) { return 'mailto:?subject=' + encodeURIComponent(t) + '&body=' + encodeURIComponent(u); }],
      linkedin: ['LinkedIn', function (u) { return 'https://www.linkedin.com/sharing/share-offsite/?url=' + encodeURIComponent(u); }],
      facebook: ['Facebook', function (u) { return 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(u); }],
      bluesky: ['Bluesky', function (u, t) { return 'https://bsky.app/intent/compose?text=' + encodeURIComponent(t + ' ' + u); }],
      x: ['X', function (u, t) { return 'https://x.com/intent/tweet?text=' + encodeURIComponent(t) + '&url=' + encodeURIComponent(u); }]
    };

    function teilen(folge, knopf) {
      var cfg = einstellungen(folge);
      var url = teilenLink(folge, cfg);
      var titel = folge.getAttribute('data-pod-titel') || document.title;
      var touch = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;

      if (navigator.share && touch) {
        navigator.share({ title: titel, url: url }).catch(function () {});
        return;
      }

      var menu = folge.querySelector('[data-pod-share-menu]');
      if (!menu) return;
      if (offenesMenu && offenesMenu.menu === menu) { menuZu(); return; }
      menuZu();

      var html = '';
      cfg.kanaele.forEach(function (k) {
        if (k === 'link') {
          html += '<li><button type="button" data-pod-copy data-url="' + esc(url) + '">Link kopieren</button></li>';
        } else if (KANAL[k]) {
          var ziel = KANAL[k][1](url, titel);
          html += '<li><a href="' + esc(ziel) + '"' + (k === 'email' ? '' : ' target="_blank" rel="noopener"') + '>' + KANAL[k][0] + '</a></li>';
        }
      });
      menu.innerHTML = html;
      menu.hidden = false;
      knopf.setAttribute('aria-expanded', 'true');
      offenesMenu = { menu: menu, knopf: knopf };
      var erstes = menu.querySelector('a, button');
      if (erstes) erstes.focus();
    }

    function altKopieren(text) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta);
    }

    function kopieren(knopf) {
      var url = knopf.getAttribute('data-url');
      var ok = function () {
        knopf.textContent = 'Link kopiert';
        setTimeout(menuZu, 1200);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(ok, function () { altKopieren(url); ok(); });
      } else {
        altKopieren(url);
        ok();
      }
    }

    /* ---------- Mehr anzeigen ---------- */
    function pruefeMehr() {
      document.querySelectorAll('.pod-folge').forEach(function (f) {
        var text = f.querySelector('[data-pod-text]');
        var knopf = f.querySelector('[data-pod-mehr]');
        if (!text || !knopf) return;
        if (text.classList.contains('is-offen')) { knopf.hidden = false; return; }
        knopf.hidden = !(text.scrollHeight > text.clientHeight + 2);
      });
    }

    function mehr(knopf) {
      var f = knopf.closest('.pod-folge');
      var text = f && f.querySelector('[data-pod-text]');
      if (!text) return;
      var offen = text.classList.toggle('is-offen');
      knopf.textContent = offen ? 'Weniger anzeigen' : 'Mehr anzeigen';
      knopf.setAttribute('aria-expanded', offen ? 'true' : 'false');
    }

    /* ---------- Sprunglink #folge-… ---------- */
    function zeigeAnker() {
      var h = '';
      try { h = decodeURIComponent(location.hash.slice(1)); } catch (e) { return; }
      if (h.indexOf('folge-') !== 0) return;
      var f = document.getElementById(h);
      if (!f || !f.classList.contains('pod-folge')) return;
      f.classList.remove('pod-versteckt');
      if (f.style.display === 'none') f.style.display = '';
      f.hidden = false;
      pruefeMehr();
      f.scrollIntoView({ behavior: 'smooth', block: 'center' });
      f.classList.add('is-hervorgehoben');
      setTimeout(function () { f.classList.remove('is-hervorgehoben'); }, 2000);
    }

    /* ---------- Hinweis bei doppelten Folgennummern (nur Editor) ---------- */
    function pruefeDoppelt() {
      if (!(window.Shopify && window.Shopify.designMode)) return;
      var gesehen = {};
      document.querySelectorAll('.pod-folge').forEach(function (f) {
        var alt = f.querySelector('.pod-hinweis--doppelt');
        if (alt) alt.parentNode.removeChild(alt);
        if (gesehen[f.id]) {
          var p = document.createElement('p');
          p.className = 'pod-hinweis pod-hinweis--doppelt';
          p.textContent = 'Nur im Editor sichtbar: Diese Folgennummer kommt mehrmals vor. Bitte jeder Folge eine eigene Nummer geben.';
          (f.querySelector('.pod-folge__text') || f).appendChild(p);
        }
        gesehen[f.id] = true;
      });
    }

    /* ---------- Ein einziger Listener für alle Folgen ---------- */
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var el;

      if ((el = t.closest('[data-pod-play]'))) {
        var f1 = el.closest('.pod-folge');
        if (f1) { e.preventDefault(); oeffnen(f1); }
      } else if ((el = t.closest('[data-pod-share]'))) {
        var f2 = el.closest('.pod-folge');
        if (f2) { e.preventDefault(); teilen(f2, el); }
      } else if ((el = t.closest('[data-pod-copy]'))) {
        e.preventDefault();
        kopieren(el);
      } else if ((el = t.closest('[data-pod-mehr]'))) {
        e.preventDefault();
        mehr(el);
      } else if (offenesMenu) {
        if (t.closest('[data-pod-share-menu]')) setTimeout(menuZu, 100);
        else menuZu();
      }

      setTimeout(pruefeMehr, 60);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && offenesMenu) {
        var k = offenesMenu.knopf;
        menuZu();
        k.focus();
      }
    });

    function aufraeumen() {
      if (aktiv && !document.body.contains(aktiv.folge)) {
        if (aktiv.controller) { try { aktiv.controller.destroy(); } catch (e) {} }
        aktiv = null;
      }
      if (offenesMenu && !document.body.contains(offenesMenu.menu)) offenesMenu = null;
    }

    function start() {
      aufraeumen();
      pruefeMehr();
      pruefeDoppelt();
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();

    function ankerStart() { setTimeout(zeigeAnker, 400); }
    if (document.readyState === 'complete') ankerStart();
    else window.addEventListener('load', ankerStart);
    window.addEventListener('hashchange', zeigeAnker);

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(pruefeMehr, 150);
    });

    ['shopify:section:load', 'shopify:block:select', 'shopify:block:deselect'].forEach(function (ev) {
      document.addEventListener(ev, function () { setTimeout(start, 50); });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
